/**
 * Cart conflict banner — removes a group of items by line-item key, then reloads.
 * Page auto-reloads after removal so pickup module re-evaluates with fresh Liquid.
 */
(function () {
  document.addEventListener('click', function (e) {
    /* Remove group button */
    var btn = e.target.closest('[data-action="remove-group"]');
    if (!btn) return;

    var keysRaw = btn.dataset.keys || '';
    var keys = keysRaw.split('|').filter(Boolean);
    if (keys.length === 0) return;

    btn.disabled = true;
    btn.textContent = 'Wird entfernt…';

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) {
        console.error('[cart-conflict-banner]', err);
        btn.disabled = false;
        btn.textContent = 'Fehler — bitte erneut versuchen';
      });
  });
})();
